import { ReactElement } from "react";
import { Route, Switch } from "wouter";
import { useFetcher } from "../hooks/use-fetcher";

export function createDocsPages<T extends { id: string }>(config: {
  /**
   * Mobile and sidebar navigation title.
   */
  title: string;

  /**
   * This determines the root path from which data will be fetched.
   */
  fetchBasePath: string;

  renderListingPage: (pages: T[]) => ReactElement;
  renderListingError: () => ReactElement;
  renderListingPending: () => ReactElement;

  renderPage: (page: T) => ReactElement;
  renderPageError: () => ReactElement;
  renderPagePending: () => ReactElement;
}) {
  function DocsListing() {
    const { data, error } = useFetcher<T[]>(
      `${config.fetchBasePath}/index.json`,
    );

    if (data) {
      return config.renderListingPage(data);
    }

    if (error) {
      return config.renderListingError();
    }

    return config.renderListingPending();
  }

  function DocsListingLayout() {
    return <DocsListing />;
  }

  function Doc(props: { pageId: string }) {
    const { data, error } = useFetcher<T>(
      `${config.fetchBasePath}/${props.pageId}.json`,
    );

    if (data) {
      return config.renderPage(data);
    }

    if (error) {
      return config.renderPageError();
    }

    return config.renderPagePending();
  }

  function DocLayout(props: { params: { pageId: string } }) {
    return <Doc pageId={props.params.pageId} />;
  }

  return function DocsPagesSwitch() {
    return (
      <Switch>
        <Route path="/" component={DocsListingLayout} />
        <Route path="/:pageId" component={DocLayout} />
      </Switch>
    );
  };
}
